<template>
  <div class="container px-0">
    <!-- Table desing begin -->
    <div class="d-none d-sm-block">
      <table id="cart" class="table table-hover table-sm">
        <thead>
          <tr>
            <th style="width:50%">Produto</th>
            <th style="width:16%">Precio</th>
            <th style="width:13%">Cantidad</th>
            <th style="width:16%" class="text-center">Subtotal</th>
            <th style="width:5%"></th>
          </tr>
        </thead>

        <transition-group name="list-shopping-cart" tag="tbody">
          <desktop-item v-for="cartItem in cartItemList" :cartItem="cartItem" :key="cartItem.id" />
        </transition-group>
      </table>
    </div>
    <!-- Table desing end -->

    <!-- Responsive desing begin -->
    <div class="d-block d-sm-none">
      <div class="list-group">
        <transition-group name="list-shopping-cart">
          <mobile-item v-for="cartItem in cartItemList" :cartItem="cartItem" :key="cartItem.id" />
        </transition-group>
      </div>
    </div>
    <!-- Responsive desing end -->
    <div class="row mt-4 no-gutters">
      <div class="col-6 col-sm-3 align-self-left d-flex align-items-center justify-content-start">
        <button class="btn btn-warning" @click="$router.push('/')">
          <span class="text-nowrap">
            <i class="fa fa-angle-left"></i> Volver atrás
          </span>
        </button>
      </div>
      <div class="col-12 col-sm-6 order-first order-sm-0 align-self-center border rounded mb-2 p-1">
        <p class="mb-1">
          Subtotal:
          <span class="float-right">
            {{ subCartValue | currency('Bs.', 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
            symbolOnLeft: true,
            spaceBetweenAmountAndSymbol: true
            })
            }}
            <template
              v-if="rate"
            >
              ({{ usdPrice(subCartValue) | currency('$', 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
              symbolOnLeft: true,
              spaceBetweenAmountAndSymbol: true
              })
              }})
            </template>
          </span>
        </p>
        <p class="mb-1">
          Servicio ({{percentFee}}%):
          <span class="float-right">
            {{ feeValue | currency('Bs.', 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
            symbolOnLeft: true,
            spaceBetweenAmountAndSymbol: true
            })
            }}
            <template
              v-if="rate"
            >
              ({{ usdPrice(feeValue) | currency('$', 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
              symbolOnLeft: true,
              spaceBetweenAmountAndSymbol: true
              })
              }})
            </template>
          </span>
        </p>
        <p class="font-weight-bold mb-0">
          Total:
          <span class="float-right">
            {{ cartValue | currency('Bs.', 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
            symbolOnLeft: true,
            spaceBetweenAmountAndSymbol: true
            })
            }}
            <template
              v-if="rate"
            >
              ({{ usdPrice(cartValue) | currency('$', 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
              symbolOnLeft: true,
              spaceBetweenAmountAndSymbol: true
              })
              }})
            </template>
          </span>
        </p>
      </div>
      <div class="col-6 col-sm-3 d-flex align-items-center justify-content-end">
        <button class="btn btn-success" @click="checkout">
          <span class="text-nowrap">
            Envíar pedido
            <i class="fa fa-angle-right d-inline"></i>
          </span>
        </button>
      </div>
    </div>
    <div class="mt-2">
      <div
        class="alert alert-success border border-success rounded"
        role="alert"
        v-if="hasDeliveryPriority"
      >
        <p class="mb-1 h5">¡Enhorabuena! tu pedido será a domicilio:</p>
        <ul>
          <li v-if="hasImportedProduct">
            <p class="m-0">
              Seleccionaste un producto con
              <span class="badge badge-pill badge-info">Delivery</span>
            </p>
          </li>
          <li v-if="exceedsUsdMinimalDelivery">
            <p class="m-0">
              Tu compra es mayor a
              <strong>
                {{ usdMinimalDelivery | currency('$', 2, {
                thousandsSeparator: ".",
                decimalSeparator: ",",
                symbolOnLeft: true,
                spaceBetweenAmountAndSymbol: true
                })
                }}
              </strong>
            </p>
          </li>
        </ul>
        <hr>
        <p class="mb-0 font-italic small">Válido sólo para Barquisimeto y Cabudare</p>
      </div>
      <div class="alert alert-info border border-info rounded" role="alert" v-else>
        <p class="mb-1 h5">Obten tu pedido a domicilio:</p>
        <ul>
          <li>
            <p class="m-0">
              Seleccionando un producto con
              <span class="badge badge-pill badge-info">Delivery</span>
            </p>
          </li>
          <li>
            <p class="m-0">
              Con una compra mayor a
              <strong>
                {{ usdMinimalDelivery | currency('$', 2, {
                thousandsSeparator: ".",
                decimalSeparator: ",",
                symbolOnLeft: true,
                spaceBetweenAmountAndSymbol: true
                })
                }}
                <template
                  v-if="rate"
                >
                  ({{ bsPrice(usdMinimalDelivery) | currency('Bs.', 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ",",
                  symbolOnLeft: true,
                  spaceBetweenAmountAndSymbol: true
                  })
                  }})
                </template>
              </strong>
            </p>
          </li>
        </ul>
        <hr>
        <p class="mb-0 font-italic small">Válido sólo para Barquisimeto y Cabudare</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { saveOrderApi } from "@/api/modules";
const DesktopItem = () => import("./cart/DesktopItem.vue");
const MobileItem = () => import("./cart/MobileItem.vue");
export default {
  computed: {
    ...mapGetters([
      "cartItemList",
      "isLoggedIn",
      "products",
      "currentUser",
      "cartValue",
      "rate",
      "feeValue",
      "subCartValue",
      "hasDeliveryPriority",
      "exceedsUsdMinimalDelivery",
      "hasImportedProduct"
    ])
  },
  data() {
    return {
      percentFee: localStorage.percentFee * 100.0,
      usdMinimalDelivery: localStorage.usdMinimalDelivery
    };
  },
  components: {
    DesktopItem,
    MobileItem
  },
  methods: {
    ...mapActions(["addMessage", "clearCart"]),
    checkout() {
      if (this.isLoggedIn) {
        this.saveOrder();
      } else {
        this.$router.push("/login");
        this.addMessage({
          messageClass: "warning",
          message: "Por favor logeate para avanzar"
        });
      }
    },
    usdPrice(bsPrice) {
      return bsPrice / this.rate;
    },
    bsPrice(usdPrice) {
      return usdPrice * this.rate;
    },
    async saveOrder() {
      const body = {
        ClientId: localStorage.ClientId,
        subtotalAmount: this.subCartValue,
        totalFee: this.feeValue,
        totalAmount: this.cartValue,
        products: this.cartItemList,
        deliveryPriority: this.hasDeliveryPriority
      };
      let serviceResponse = await saveOrderApi(body);
      let message_obj = {
        message: serviceResponse.message.text,
        autoClose: true
      };
      message_obj.messageClass = serviceResponse.status ? "success" : "danger";
      this.addMessage(message_obj);
      if (serviceResponse.status) {
        this.clearCart();
        this.$router.push("/");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.list-shopping-cart-leave-active {
  transition: all 0.4s;
}

.list-shopping-cart-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

.table-sm {
  font-size: 0.875rem;
  /deep/ h4 {
    font-size: 1.25rem;
  }
}
</style>
